import script from "./GiftSend.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftSend.vue?vue&type=script&setup=true&lang=js"

import "./GiftSend.vue?vue&type=style&index=0&id=610cbc33&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610cbc33"]])

export default __exports__